/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { Parameters } from "../Context";

export function useExportQuery(
    title: string, 
    subtitle: string, 
    source:string | undefined | null,
    parameters: Parameters | null | undefined
) {
  const exportBuilder = useExport();
  const [commodities] = useParameter<number>("@commodities");
  const [units] = useParameter<number>("@units");
  const [frequencies] = useParameter<number>("@frequencies");
  const [startDate] = useParameter<number>("@start_date");
  const [endDate] = useParameter<number>("@end_date");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('source', source)
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@calendar": parameters?.calendar,
        "@commodities": commodities,
        "@units": units,
        "@frequencies": frequencies,
        "@start_date": startDate,
        "@end_date": endDate,
      }
    });
  }, [title, subtitle, exportBuilder, parameters?.calendar, commodities, units, frequencies, startDate, endDate, source]);
}

